var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { omit } from "lodash";
import id from "@irati/utils/id";
import { Icon, ButtonRouterLink } from "./styled";
var IconButtonRouterLink = function (props) {
    var idNamespace = id("IconButtonRouterLink", props);
    var children = props.children;
    var iconProps = omit(props, ["onClick", "className"]);
    return (React.createElement(ButtonRouterLink, __assign({ id: idNamespace }, props),
        React.createElement(Icon, __assign({ hasChildren: !!children }, iconProps)),
        children));
};
export default IconButtonRouterLink;
